import React, { useEffect, useState } from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import css from './ListingPage.module.css';
import { getDownloadUrlFromFirebase } from '../../util/firebase';

const SectionGallery = (props) => {
  const { listing, variantPrefix } = props;
  const firebaseVideo = listing?.attributes?.publicData?.firebaseVideo;

  const [firebaseVideoUrl, setFirebaseVideoUrl] = useState(null);
  useEffect(() => {
    if (!firebaseVideo) return;
    getDownloadUrlFromFirebase({ fileName: firebaseVideo, folderName: 'listings-videos' })
      .then((resp) => {
        if (resp?.url) {
          setFirebaseVideoUrl(resp.url);
        }
      })
      .catch((error) => {
        console.error('Error getting download URL:', error);
      });
  }, []);
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  const youtubeUrl = listing?.attributes?.publicData?.youtubeVideoUrl;
  const embedYoutubeUrl = youtubeUrl && youtubeUrl.replace('watch?v=', 'embed/');

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        embedYoutubeUrl={embedYoutubeUrl}
        firebaseVideoUrl={firebaseVideoUrl}
      />
    </section>
  );
};

export default SectionGallery;
